/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styles from './onboardingMobileview.module.scss';
import UseAxios from '../../../Api/http/http';
import PropTypes from 'prop-types';
import { AuthContext } from '../../../Contexts/AuthContext';
import { formatDate } from '../../../Utils/formatDate';
import defaultImage from '../../../Assets/images/svg/user_circle.svg';
import { MODULE_NAMES } from '../../../Constants/modules';
import noDataIcon from '../../../Assets/images/svg/no-data-search-icon.svg';

const OnboardingMobilePage = ({
  organizationDetails,
  totalExperience,
  loading,
  hiringDetails,
}) => {
  const [expanded, setExpanded] = useState([]);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const handleGetActions = async () => {
    const token = localStorage.getItem('userRolesToken');
    try {
      const response = await UseAxios(getRecognition(token));
      if (response?.data?.recognitions) {
        setRecognitions(response.data.recognitions);
      }
    } catch (error) {}
  };
  useEffect(() => {
    handleGetActions();
  }, []);
  const { userProfile } = useContext(AuthContext);
  const permission = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.EMPLOYEE_ONBOARDING] || []
    : [];

  const hasAccess = (action) => {
    const access = permission.includes(action);
    return access;
  };

  return (
    <div className={styles['onboard-page']}>
      {hasAccess('read') && (
      <>
        <div className={styles['onboard-page-outer-div']}>
          <div className={styles['onboard-page-heading-div']}>
            <div className={styles['onboard-heading-name']}>
              Hiring details
            </div>
          </div>

          <div className={styles['onboard-details-accordion']}>
            {!loading &&
              hiringDetails?.map((interview, index) => (
                <Accordion
                  key={interview.id}
                  className={styles['onboard-details-accordion-sec']}
                  expanded={expanded === index + 1}
                  onChange={handleChange(index + 1)}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    className={styles['onboard-details-accordion-item']}
                  >
                    <div className={styles['round-circle']}>
                      <div className={styles['round-text']}>Round</div>
                      <div className={styles['number-text']}>{index + 1} </div>
                    </div>
                    <div
                      className={styles['hiring-details-container']}
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                      }}
                    >
                      <Typography
                        variant={'h6'}
                        className={styles['hiring-details-accordion-heading']}
                        style={{ marginBottom: '0.25rem' }}
                      >
                        {interview?.interviewRounds}
                      </Typography>
                      <div className={styles['hiring-datess-details']}>
                        {formatDate(interview?.interviewTime)}
                      </div>
                    </div>
                  </AccordionSummary>
                  <AccordionSummary
                    className={styles['hiring-details-accordion-details']}
                  >
                    <div className={styles['hiring-details-accordion-panel']}>
                      <div
                        className={styles['hiring-details-accordion-inner-sec']}
                      >
                        <div className={styles['hiring-details']}>
                          <div className={styles['image-circle']}>
                            <img
                              src={
                                interview?.interviewer?.photoSignedUrl ||
                                defaultImage
                              }
                              alt="Description"
                            />
                          </div>
                        </div>
                        <div className={styles['interview-details']}>
                          <div className={styles['interview_name']}>
                            {interview?.interviewer?.full_name || 'NA'}
                          </div>
                          <div className={styles['interview_id']}>
                            <span>
                              {interview?.interviewer?.employee_id || 'NA'}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </AccordionSummary>
                </Accordion>
              ))}

            {!loading && hiringDetails?.length === 0 && (
              <div className={styles['no-data-container-mobile']}>
                <div className={styles['no-data-wrapper-mobile']}>
                  <span className={styles['no-data-icon-mobile']}>
                    <img src={noDataIcon} alt="No data" />
                  </span>
                  <span className={styles['no-data-text-mobile']}>
                    No data to display
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>

          {/* Previous organization details section */}
          <div className={styles['organization-page-outer-div']}>
            <div className={styles['organization-page-heading-div']}>
              <Typography className={styles['organization-heading-name']}>
                Previous organization details
              </Typography>
              <Typography className={styles['experience-text']}>
                <span className={styles['label-text']}>
                  Total previous experience:
                </span>
                <span className={styles['value-text']}>
                  {totalExperience || 'No experience available'}
                </span>
              </Typography>
            </div>
            <div className={styles['org-details-sec']}>
              <div className={styles['org-details-sec-inner']}>
                {organizationDetails && organizationDetails.length > 0 ? (
                  organizationDetails.map((experience, index) => (
                    <div key={index+1} className={styles['container']}>
                      <div className={styles['org-name']}>
                        {experience.employer}
                      </div>
                      <div className={styles['org-details']}>
                        {experience.jobtitle}
                      </div>
                      <div className={styles['org-date']}>
                        {experience.fromDate} - {experience.toDate}
                      </div>
                    </div>
                  ))
                ) : (
                  <Typography>
                    No previous employment details available.
                  </Typography>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
OnboardingMobilePage.propTypes = {
  organizationDetails: PropTypes.arrayOf(PropTypes.object).isRequired,
  totalExperience: PropTypes.arrayOf(PropTypes.object).isRequired,
  loading: PropTypes.bool.isRequired,
  hiringDetails: PropTypes.arrayOf(PropTypes.object).isRequired,
};
export default OnboardingMobilePage;
